<template>
  <DarkCard>
    <template #header>
      <div>All Insights</div>
      <i class="fa fa-comment-o"></i>
    </template>
    <template #body>
      <span>{{ insights.total ?? "--" }}</span>
    </template>
    <template #footer>
      <span class="red-color">
        {{ insights[EventLogLevel.HIGH] }} high,
        {{ insights[EventLogLevel.MEDIUM] }} medium
      </span>
    </template>
  </DarkCard>
</template>

<script>
import DarkCard from "./DarkCard.vue";
import { getEventInsights } from "@/api";
import { EventBus } from "@/event-bus";
import { EventLogLevel } from "@/enums";
//All insights就是三方 AI给的总 Alert数吧
export default {
  name: "AllInsights",
  components: {
    DarkCard,
  },
  computed: {
    EventLogLevel: () => EventLogLevel,
  },
  data() {
    return {
      insights: {
        0: 0,
        1: 0,
        2: 0,
        total: 0,
      },
    };
  },
  methods: {
    // 这里可以替换为实际的 API 调用
    async fetchInsights() {
      // 这里可以替换为实际的 API 调用
      const res = await getEventInsights();
      this.insights = res;
    },
  },
  mounted() {
    // 这里可以替换为实际的 API 调用
    this.fetchInsights();
    EventBus.$on("event-log-refreshed", this.fetchInsights);
  },
  beforeDestroy() {
    EventBus.$off("event-log-refreshed", this.fetchInsights);
  },
};
</script>
<style scoped>
.red-color {
  color: #a96d72;
}
</style>
